import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

export interface IState {
    getAll(options: ODataOptions, jwt: string): Promise<object>;
}

export default class State extends BaseApi implements IState {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    getAll = (options: ODataOptions, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/states/${options.toString()}`, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/State.ts